import { IndexDbName } from '@/core/helpers/http.helper';

/**
 * It returns an object with two functions, one to initialize the IndexedDB and one to clear the cache
 * and refresh the page.
 * @returns An object with two properties: initIndexDb and clearCacheAndRefresh.
 */
function useIndexedDb() {
   function initIndexDb(): Promise<IDBDatabase> {
      return new Promise((resolve, reject) => {
         const request = window.indexedDB.open(IndexDbName, 2);

         request.onsuccess = () => resolve(request.result);
         request.onerror = () => reject(new Error('Could not get indexedDB'));
      });
   }

   async function clearCache(callback?: () => void) {
      const db = await initIndexDb();

      const request = db.transaction('keyvaluepairs', 'readwrite').objectStore('keyvaluepairs').clear();
      request.onsuccess = () => {
         if (callback) callback();
      };
   }

   async function clearCacheAndRefresh() {
      return clearCache(() => window.location.reload());
   }

   return { initIndexDb, clearCacheAndRefresh, clearCache };
}

export { useIndexedDb };
